// src/components/atoms/LockedByExaminationBanner.js
//
// Hasta Detay sayfasının üstünde render edilir; hasta'nın status==="in_progress"
// muayenesi varsa kullanıcıya neden düzenleyemediğini bildirir.

import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";
import { format } from "date-fns";
import { tr } from "date-fns/locale";

import { useClinicTheme } from "../../theme";
import { COLORS } from "../../styles/uiConstants";

const formatStartedAt = (val) => {
  if (!val) return "";
  try {
    return format(new Date(val), "d MMM yyyy HH:mm", { locale: tr });
  } catch (_) {
    return "";
  }
};

export default function LockedByExaminationBanner({ exam }) {
  const { palette } = useClinicTheme();
  if (!exam) return null;
  const doctor = exam.doctorName || "Doktor";
  const when = formatStartedAt(exam.startedAt);

  return (
    <Box
      role="status"
      sx={{
        mx: { xs: 2, md: 3 },
        my: 1.5,
        px: 2,
        py: 1.25,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        borderRadius: 2,
        border: `1px solid ${alpha(palette.primary, 0.25)}`,
        bgcolor: alpha(palette.primary, 0.08),
        color: palette.primary,
      }}
    >
      <LockIcon sx={{ fontSize: 20 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: "0.85rem" }}>
          Bu hasta şu an muayenede
        </Typography>
        <Typography
          sx={{ fontSize: "0.78rem", color: COLORS.slate600, fontWeight: 500 }}
        >
          {doctor}
          {when ? ` — ${when}` : ""}. Kayıtlar görüntülenebilir, düzenleme yapılamaz.
        </Typography>
      </Box>
    </Box>
  );
}
